import React,{useState,useEffect} from 'react';
//import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
//import MenuItem from '@mui/material/MenuItem';
//import {useStyles} from './useStyles';
import {Tools} from './Tools';
import {Dataset} from './Inc';

interface InputStringProps {
	label:string,
	value:string,
	required:boolean,
	list?: Dataset[],
	helper?:string,
	enableTags?:boolean,
	onChange(value:string,hasError:boolean):void,
	duplicate?(value:string):any,
	duplicateError?:string,
	regex?:string,
	regexError?:string,
	opt?:{[key:string]:any;},
	convert?(value:string):string,
}

const InputString:React.FC<InputStringProps> = (props)=> {
	const [states,setStates] = useState({
		value: props.value,
		duplicated: false,
		error: '',
	});
	//const [composition,setComposition] = useState(false);
	const getError = (value:string)=>{
		let error = '';
		if( states.duplicated ){
			error = 'この'+props.label+'はすでに使われています';
		}
		if( props.required ){
			if( value==='' ){
				error = props.label+'を入力してください';
			}
		}
		if( props.opt ){
			if( props.opt["minLength"] && value ){
				if( value.length>0 && value.length<props.opt["minLength"] ){
					error  = props.label + 'は'+props.opt["minLength"]+'文字以上にしてください';
				}
			}
			if( props.opt["maxLength"] && value ){
				if( value.length>props.opt["maxLength"] ){
					error = props.label + 'は'+props.opt["maxLength"]+'文字以内にしてください';
				}
			}
		}
		if( props.regex ){
			if( value!=='' ){
				var result = states.value.match(props.regex);
				if( !result ){
					if( props.regexError ){
						error = props.regexError;
					} else {
						error = props.label+'が正しくありません。';
					}
				}
			}
		}
		return error;
	}
    const blur = async ()=>{
		let error = '';
		if( props.duplicate ){
			const res = await props.duplicate(states.value);
			//console.log('deplicate',res);
			if( res.used ){
				if( props.duplicateError ){
					error = props.duplicateError;
				} else {
					error = 'この'+props.label+'はすでに使われています';
				}
			}
		}
		if(error!==''){
			setStates(prev=>({...prev,duplicated:true,error:error}));
			props.onChange(states.value,true);
		} else {
			//props.onChange(states.value,states.error!=='');
			let value = "";
			if( props.enableTags ){
				value = states.value;
			} else {
				value = Tools.stripTags(states.value);
			}
			if(props.convert){
				value = props.convert(value);
			}

			const error = getError(value);
			//console.log("blur",value,error);
			//if( value!==states.value ){
			setStates(prev=>({...prev,value:value,error:error}));
			//}
			props.onChange(value,error!=='');
		}
    }
	const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		//console.log("change",value);
		//if(!composition){
			//validate(value);
			setStates(prev=>({...prev,value:value}));
		//} else {
			//setStates(prev=>({...prev,value:value}));
		//}
	}
	// const onCompositionStart = ()=>{
	// 	console.log("start");
	// 	setComposition(true);
	// }
	// const onCompositionEnd = ()=>{
	// 	console.log("end");
	// 	setComposition(false);
	// 	validate(states.value);
	// }
	// const validate = (value:string)=>{
	// 	console.log("validate");
	// 	setStates(prev=>({...prev,value:value,error:getError(value)}));
	// }

	let rows:number = 1;
	if( props.opt && props.opt["rows"] ){
		rows = props.opt["rows"];
	}
	let type:"text"|"time" = "text";
	if( props.opt && props.opt["type"] ){
		type = props.opt["type"];
	}

	let inputLabelProps:any = {};
	let inputProps:any = {};
	let placeholder = "";
	let required = false;
	let maxLength = 0;
	let rest = 0;
	let classCounter = "formCounter";
	let fullWidth = true;
	let disabled = false;
	if( props.opt ){
		if( props.opt["shrink"]===true ){
			inputLabelProps["shrink"] = true;
		}
		if( props.opt["startAdornment"] ){
			inputProps["startAdornment"] = <InputAdornment position='start' style={{whiteSpace:'nowrap',marginRight:'1em'}}>{props.opt["startAdornment"]}</InputAdornment>;
		}
		if( props.opt["endAdornment"] ){
			inputProps["endAdornment"] = <InputAdornment position='end' style={{whiteSpace:'nowrap'}}>{props.opt["endAdornment"]}</InputAdornment>;
		}
		if( props.opt["maxLength"] ){
			maxLength = props.opt["maxLength"];
			rest = maxLength;
			const v = states.value as string;
			if( v ){
				rest -=  v.length;
				if( rest<0 ){
					classCounter += " formCounterMinus";
				}
			}
		}
		if( props.opt["placeholder"] ){
			placeholder = props.opt["placeholder"];
		}
		if( props.opt["required"] ){
			required = props.opt["required"];
		}
		if( props.opt["fullWidth"]===false ){
			fullWidth = false;
		}
		if( props.opt["disabled"]===true ){
			disabled = true;
		}
	}
	//inputProps["autoComplete"] = 'off';
	//inputProps["form"] = {autocomplete:'off'};

	let helper = '';
	if(states.error!==''){
		helper = states.error;
	} else if( props.helper ){
		helper = props.helper;
	}

	useEffect(()=>{
		//if( !states.value || props.value !== states.value ){
			setStates(prev=>({
				...prev,
				duplicated:false,
				value: props.value,
				//error: "",
				//error: getError(props.value),
			}));
		//}
	},[props.value])

	return (
		<FormControl fullWidth={fullWidth}>
			<TextField
				label={props.label}
				variant="filled"
				onChange = {onChange}
				value={states.value}
				error={states.error!==''}
				helperText={helper}
				placeholder={placeholder}
				rows={rows}
				required={required}
				multiline={rows>1}
				InputLabelProps = {inputLabelProps}
				InputProps = {inputProps}
				type={type}
				disabled={disabled}
				onBlur={blur}
				//onCompositionStart={onCompositionStart}
				//onCompositionEnd={onCompositionEnd}
				sx={{
					"& .MuiFormHelperText-root": {
						marginLeft: 0,
						paddingLeft: 0,
						color: states.error !== '' ? 'red' : 'teal', // エラー時は赤、通常はteal
					}
				}}
			/>
			{maxLength>0 &&
			<div className={classCounter}>{rest}</div>
			}
		</FormControl>
	);	
}

export default InputString;